<template>
    <div class="main">
       <div class="mapComment">
           <div class="mapUserBackMain">
               <div class="mapUserBackMainItem">
                   <!-- <div class="mainContTop">
                     <div class="mainContTopImg"><img :src="imgUrl+img" :onerror="defaultImg" alt=""></div>
                     <div class="mapUserBackMainItemTil van-multi-ellipsis--l2">{{name}}</div>
                   </div> -->
                   <div class="scoreBox">
                     <div class="scoreBoxLeft">
                       <div class="scoreTil">评分</div>
                        <div class="startBox">
                            <div class="startImg" v-for="(item,index) in 5" :key="index" @click="changeStart(index)"><img :src="start<=index?require('../assets/star_active.png'):require('../assets/star.png')" alt=""></div>
                            <!-- <div class="startImg"><img src="../../assets/imgs/startStart.png" alt=""></div> -->
                        </div>
                     </div>
                    <div class="scoreBoxRight">{{scoreText}}</div>
                   </div>
                    <div class="mapUserMainField">
                        <van-field
                            v-model="message"
                            rows="3"
                            autosize
                            type="textarea"
                            placeholder="请输入您的评论"
                            />
                        <van-uploader :after-read="afterRead" :before-delete="deletePhoto" v-model="imgList" multiple :max-count="3" />
                    </div>
               </div>
           </div>
          <div class="addHomeBom" >
            <van-button type="primary" color="#3B87F5" @click="addComment">发布</van-button>
          </div>
       </div>
    </div>
</template>

<script>
import Vue from 'vue'
import qs from 'qs'
import { Picker,Field,Uploader,Toast } from 'vant'
import { addBaseAplus } from '../utils/zzdmd.js'
Vue.use(Picker)
Vue.use(Field)
Vue.use(Uploader)
Vue.use(Toast)
export default {
  data () {
    return {
        message:'',
        fileList:[],
        imgList: [],
        start:0,
        // img:this.$route.query.img,
        id:this.$route.query.id,
        oid:this.$route.query.oid,
        // name:this.$route.query.name,
        cantClick:true,
        scoreText:''
    }
  },
  created () {
    this.init()
  },
  mounted(){
    addBaseAplus(this.$route)
  },
   activated(){
      this.init()
  },
  methods: {
      init(){
          this.imgList=[]
          this.fileList= []
          this.start = 0
          this.message = ''
          this.id=this.$route.query.id
          this.oid=this.$route.query.oid
          this.cantClick = true
      },
    addComment(){
        if(!this.cantClick){
            return
        }
        if(this.start==0){
            Toast({
                message: '请选择评分',
                position: 'bottom',
            })
            return
        }
        if(this.message==''){
            Toast({
                message: '评论不能为空',
                position: 'bottom',
            })
            return
        }
        this.cantClick = false
        var that = this
        // let data = {
        //     hid:this.$route.query.id,
        //     uid:JSON.parse(sessionStorage.getItem('userId')),
        //     score:this.start,
        //     presentPicture:this.fileList.join(','),
        //     comment:this.message
        // }
        let param = {
            eCanteenID:this.id,
            eOrderID:this.oid,
            eContent:this.message,
            ePicture:this.fileList.join(','),
            eScore:this.start,
            eWorkerID:JSON.parse(sessionStorage.getItem('userData')).workerID
            // eWorkerID:'11'
        }
        this.$post('api/Order/SetEvaluate', qs.stringify(param), {
            headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then(function (res) {
           if(res.code==1000){
               Toast({
                message: '评论成功',
                position: 'bottom',
                })
               that.init()
                setTimeout(function(){
                    that.cantClick = true
                    that.$router.go(-1)
                },1000)
            }else{
                 Toast({
                    message: res.msg||res.message,
                    position: 'bottom',
                })
                setTimeout(function(){
                    that.cantClick = true
                },1000)
            }
        })
    },
    afterRead(file){
      let param = {
          File:file.file
      }
      this.$post('api/Tools/UploadSinglePic',param,{
          headers: {
              "Content-Type": "multipart/form-data"
          },
      }).then((res)=>{
          if(res.code==1000){
              this.fileList.push(res.data.path)
          }else{
              this.imgList.splice(this.imgList.length-1,1)
              Toast({
                message: res.msg||res.message,
                position: 'bottom',
            })
          }
        })
    },
     deletePhoto(file,detail){
        this.imgList.splice(detail.index,1)
        this.fileList.splice(detail.index,1)
    },
    changeStart(idx){
        this.start = idx-0+1
        switch (this.start) {
          case 0:
            this.scoreText = ''
            break;
          case 1:
            this.scoreText = '非常不满意'
            break;
          case 2:
            this.scoreText = '不满意'
            break;
          case 3:
            this.scoreText = '一般'
            break;
          case 4:
            this.scoreText = '满意'
            break;
          case 5:
            this.scoreText = '非常满意'
            break;
          default:
            break;
        }
    }
  }
}
</script>

<style scoped>
    .main{
        min-height: 100vh;
      background-color: #f4f4f4;
    }
    .mapComment{
        width: 100%;
        min-height: 100vh;
        box-sizing: border-box;
        padding: 10px  0;
    }
    .mapUserBackMain{
        width: 100%;
        box-sizing: border-box;
        padding:10px;
        background: #FFFFFF;
        border-radius: 5px;
    }
    .mapUserBackMainItem{
        box-sizing: border-box;
    }
    .mapUserBackMainItemTil{
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #000000;
        width: calc(100% - 53px);
        height: 44px;
    }
    .mapUserBackMainItemExpBox{
        width: 100%;
    }
    .mapUserBackMainItemExpBox ul{
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        box-sizing: border-box;
        padding: 5px 0;
    }
    .mapUserBackMainItemExpBox ul li{
        background: #E6E6E6;
        border-radius: 14px;
        box-sizing: border-box;
        padding: 6px 13px;
        font-size: 13px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #666666;
        margin: 5px;
    }
    .mapUserBackMainItemActive{
        background: #248FF3 !important;
        color: #FFFFFF !important;
    }
    .mapUserBackMainItemSelectBox{
        width: 100%;
        height: 34px;
        margin: 10px 0;
        background: #FFFFFF;
        border: 1px solid #E6E6E6;
        border-radius: 5px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        padding: 0 10px;
    }
    .mapUserBackMainItemSelectBoxIput{
        width: 80%;
    }
    .mapUserBackMainItemSelectBoxIput input{
        width: 100%;
        border: none;
        outline: none;
        background-color: #FFFFFF;
    }
    .rightImg{
        width: 6px;
        height: 10px;
        transform: rotate(90deg);
    }
    .rightImg img{
        width: 100%;
        height: 100%;
    }
    .van-cell{
        padding: 0;
        background: #fff;
        margin-bottom: 10px;
        border-radius: 5px;
        box-sizing: border-box;
        padding: 10px;
    }
    .van-cell::after{
        border: none;
    }
    .mapUserMainField{
        width: 100%;
        border-radius: 5px;
        margin-top: 10px;
    }
    
    .mapUserBackBtnBox{
        width: 100%;
        position: fixed;
        left: 0;
        bottom: 10px;
        box-sizing: border-box;
        padding: 0 13px;
    }
    .mapUserBackBtn{
        width: 100%;
        height: 49px;
        background: #248FF3;
        border-radius: 5px;
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .startBox{
        margin-left: 10px;
        display: flex;
        align-items: center;
    }
    .startImg{
        width: 15px;
        margin-right: 5px;
    }
    .startImg img{
        width: 100%;
        height: 100%;
    }
    .mainContTop{
      display: flex;
      justify-content: space-between;
    }
    .mainContTopImg{
      width: 40px;
      height: 40px;
      border-radius: 5px;
      overflow: hidden;
    }
    .mainContTopImg>img{
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .scoreBox{
      margin: 15px 0 5px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .scoreBoxLeft{
      display: flex;
      align-content: center;
    }
    .scoreBoxRight{
      font-size: 12px;
      font-weight: 500;
      color: #666666;
    }
    .scoreTil{
      font-size: 14px;
    }
    .addHomeBom{
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 54px;
        box-sizing: border-box;
        padding: 0 18px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        /* background-color: #fff;
        border-top: 1px solid #ebedf0; */
    }
.van-button{
    padding: 0 105px;
    width: 100%;
    height: 36px;
    border-radius: 18px;
    white-space: nowrap;
    box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
}
.addBtnBox{
    width: 53px;
    height: 53px;
    border-radius: 50%;
    background-color: #5677FC;
    position: fixed;
    right: 18px;
    bottom: 80px;
}
.addBtn{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/page/comment.vue